import React from 'react';
import './styles.css';
import NavBar from './NavBar';

const Features = () => {
  const features = [
    {
        title: "The Pool: Your Local Social Scene",
        description: "Jump into a live pool of real people in your city. No algorithms—just presence.",
        icon: "🌊"
    },
    {
        title: "Splash to Get Noticed",
        description: "Like someone? Send a splash to rise to the top of their pool and get their attention.",
        icon: "💦"
    },
    {
        title: "Instant Face-to-Face Video",
        description: "Skip the awkward texting. Click 'Connect' to jump straight into a real video conversation.",
        icon: "🎥"
    },
    {
        title: "Connect to Unlock Chat",
        description: "If the vibe is right, both of you can connect and unlock text chat to keep the convo going.",
        icon: "🔓"
    },
    {
        title: "Control Your Pool",
        description: "See who splashed you, manage who stays in your pool, and remove anyone you're not feeling.",
        icon: "🧼"
    },
    {
        title: "Boosts & SuperSplashes",
        description: "Use Boosts or SuperSplashes to rise in visibility and attract more meaningful attention.",
        icon: "🚀"
    },
    {
        title: "Smart Filters",
        description: "Dial in your preferences with filters to find people who match your vibe and interests.",
        icon: "🎯"
    },
    {
        title: "Real. Human. Connection.",
        description: "Pool Party brings authenticity and spontaneity back to socializing. Meet real people, make real friends.",
        icon: "🫶"
    },
    {
        title: "You Never Know Who You'll Meet",
        description: "Find someone new today. Your next best friend might be one splash away.",
        icon: "✨"
    }
  ];

  const renderFeatureCard = (feature, index) => (
    <div key={index} className="feature-card2">
        <div className="feature-icon">{feature.icon}</div>
        <h3 className="feature-title">{feature.title}</h3>
        <p className="feature-description">{feature.description}</p>
    </div>
  );

  const renderSEODescription = () => (
    <div className="seo-text-section">
      <h2>Unique Features That Set Pool Party Social Club Apart</h2>
      <p>Pool Party Social Club isn't just another social app—it's a <strong>video-first social experience</strong> built for people who are tired of endless scrolling, ghosting, and awkward small talk. With features like <strong>instant video chat</strong>, <strong>splash-based visibility</strong>, and <strong>real-time local pools</strong>, Pool Party helps you make authentic connections the way socializing was meant to be—<strong>spontaneous, human, and face-to-face</strong>.</p>
      <p>Unlike other apps, we don't make you scroll through walls of profiles or wait for text replies. Our <strong>real-time video connections</strong> mean you meet people in the moment, with people near you, right now. Say goodbye to fake profiles and meaningless interactions. Say hello to <strong>genuine conversations</strong>, <strong>real people</strong>, and a social environment built for those who want something authentic.</p>
      <p>From our customizable <strong>filters</strong> and <strong>Boosts</strong> to our emphasis on <strong>control and safety</strong>, Pool Party gives you the tools to meet who you want, how you want. We believe in <strong>socializing without algorithms</strong> and putting you in charge of your social life. This is what makes Pool Party Social Club the <strong>best app for authentic face-to-face connections</strong>.</p>
    </div>
  );

  return (
    <>
      {NavBar()}
      <div className="features-screen-wrapper">
        <div className="features-hero">
          <h1 className="features-title">Why You'll Love Pool Party Social Club</h1>
          <p className="features-subtitle">Genuine, spontaneous, and face-to-face. Pool Party makes it easy to meet real people near you.</p>
        </div>
        <div className="features-grid">
          {features.map(renderFeatureCard)}
        </div>
        {renderSEODescription()}
      </div>
    </>
  );
};

export default Features;
